import { render } from "./PrintInvitation.vue?vue&type=template&id=f6e62cf8&scoped=true&ts=true"
import script from "./PrintInvitation.vue?vue&type=script&lang=ts"
export * from "./PrintInvitation.vue?vue&type=script&lang=ts"

import "./PrintInvitation.vue?vue&type=style&index=0&id=f6e62cf8&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6e62cf8"]])

export default __exports__